import * as React from 'react';
//import { useTheme } from '@mui/material/styles';
//import { LineChart, Line, XAxis, YAxis, Label, ResponsiveContainer } from 'recharts';
import Title from './Title';
import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import TableBody from '@material-ui/core/TableBody';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import { ThemeProvider } from '@material-ui/core'
import { createTheme } from '@material-ui/core/styles';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import TextField from '@mui/material/TextField';
import { useForm } from 'react-hook-form';
import { Typography } from '@mui/material';
import { Fragment } from 'react';
import { Grid } from '@mui/material';
import * as Yup from 'yup';
import { useState } from 'react';
import { yupResolver } from '@hookform/resolvers/yup';
import { GetAccessToken, fetcher } from "./Utilities";
import SuccessError from "../Widgets/SuccessError";
import { FormControlLabel, FormGroup } from '@mui/material';
import Checkbox from '@mui/material/Checkbox';

const theme = createTheme({
  overrides: {
    MuiTableCell: {
      root: {  //This can be referred from Material UI API documentation. 
        padding: '0px 4px',
        // backgroundColor: "#eaeaea",
      },
    },
  },
});

const RequestCard = (props) => {
  const [openReminder, setOpenReminder] = useState(false);
  const [openRemoveRequest, setOpenRemoveRequest] = useState(false);
  const [subject, setSubject] = useState('');
  const [accessToken, setAccessToken] = useState(false);
  const [userName, setUserName] = useState('');
  const [tenantName, setTenantName] = useState(false);
  const [adminUser, setAdminUser] = useState(false);
  const [emailBody, setEmailBody] = useState('');
  const [sentTo, setSentTo] = useState('');
  const [requestId, setRequestId] = useState(0);
  const [errorOpen, setErrorOpen] = React.useState(false);
  const [successOpen, setSuccessOpen] = React.useState(false);
  const [successMessage, setSuccessMessage] = React.useState(false);
  const [errorMessage, setErrorMessage] = React.useState(false);
  const [hideCompleteRequests, setHideCompleteRequests] = React.useState(false);
  const [requestSuccessOpen, setRequestSuccessOpen] = React.useState(false);
  const [requestSuccessMessage, setRequestSuccessMessage] = React.useState(false);



  let args = ['user', GetAccessToken()];
  //console.log(args);
  fetcher(args).then((responseData) => {

    //console.log(responseData);
    //setResponseData(responseData);
    setTenantName(responseData.tenantName);
    setAdminUser(responseData.isSuperAdmin);
    setUserName(responseData.userName);
    //setLogoFile(responseData.logoFile);
    //setHasGovernanceModule(responseData.hasGovernanceModule);

  });


  const requestSubmit = (data) => {
    //debugger;
    clearErrors();
    setOpenReminder(false);
    data.requestId = requestId;
    data.sentTo = sentTo;
    data.subject = subject;
    data.note = emailBody;
    saveVendorRequestReminder(data);

  };
  async function saveVendorRequestReminder(data) {

    var method = 'POST';
    var url = 'vendors/saverequestreminder';

    try {
      const requestOptions = {
        method: method,
        withCredentials: true,
        credentials: 'include',
        headers: {
          'Authorization': localStorage.getItem("userToken"),
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
      };

      var result = await fetch(url, requestOptions);
    } catch (e) {

      showError("An error occurred while sending the reminder.");
    } finally {
      //reRender = reRender + 1;
      //console.log(reRender);
      showSuccess('Reminder Sent');

    }


  }
  const showSuccess = message => {
    setSuccessOpen(true);
    setSuccessMessage(message);
    setTimeout(() => setSuccessOpen(false), 3000);
  };
  const showError = message => {
    setErrorOpen(true);
    setErrorMessage(message);
    setTimeout(() => setErrorOpen(false), 3000);
  };
  const closeSuccess = () => {
    setSuccessOpen(false);
  };
  const closeError = () => {
    setErrorOpen(false);
  };
  const showSendReminder = (event, row) => {

    setOpenReminder(true);
    setSubject(tenantName + " - PIA Request Reminder");
    setEmailBody(tenantName + ' has made a privacy impact Assessment request for your company.  Please follow this' + ' link (created when sent)' + ' to enter the necessary information.\n\n' +
      'Please answer each of the areas as best you can.  If there is something you cannot answer, then please put it in the general notes box in each of the corresponding areas\n\n' +
      'Thank you\n' + userName);

    let args = ['vendors/getrequestbyid?id=' + row.requestId, accessToken];
    //console.log(args);
    fetcher(args).then((responseData) => {

      setSentTo(responseData.sentTo);
      setRequestId(row.requestId);
      // setTenantName(responseData.tenantName);
      // setAdminUser(responseData.isSuperAdmin);
      // setUserName(responseData.userName);


    })
  };
  const showRemoveRequest = (event, row) => {

    setOpenRemoveRequest(true);
    setRequestId(row.requestId);

  };
  const removeRequest = (data) => {
  
    clearErrors();
    setOpenRemoveRequest(false);

    let args = ['vendors/removerequestbyid?id=' + requestId, accessToken];

    //console.log(args);
    // debugger;
    // props.rows = props.rows.filter(request => request.requestId !== requestId);
    
    fetcher(args).then(() => {
      setSuccessOpen(true);
      setSuccessMessage('Request Removed');
      setTimeout(() => setSuccessOpen(false), 3000);
      // Refresh the page to reflect the changes after removing the request
      setTimeout(() => window.location.reload(), 5000);
     ;

    
    }).catch((error) => {
      setErrorOpen(true);
      setErrorMessage('An error occurred while removing the request.');
      setTimeout(() => setErrorOpen(false), 3000);
    });
  };
  const closeDialog = () => {
    setOpenReminder(false);
    setOpenRemoveRequest(false);
  }

  const validationSchema = Yup.object().shape({
    vendorId: Yup.string(),
    accessToken: Yup.string(),
    sentTo: Yup.string()
      //.required('Email is required.')
      .max(250, 'Email not exceed 250 characters')
      .email('Email must be a valid email address.'),
    subject: Yup.string()
      //.required('Subject is required.')
      .max(250, 'Subject not exceed 250 characters'),
    note: Yup.string()
      .max(1500, 'Note must not exceed 1500 characters'),

  });
  const handleCompleteRequestChange = () => {
    setHideCompleteRequests(!hideCompleteRequests);
  };
  const {
    register,
    //control,
    //setValue,
    handleSubmit,
    clearErrors,
    formState: { errors }
  } = useForm({
    resolver: yupResolver(validationSchema)
  });
  if (!props.rows) {

    return (<Title>{props.title}</Title>);
  }
  else {
    return (
      <React.Fragment>
        <SuccessError
          successMessage={successMessage}
          errorMessage={errorMessage}
          closeError={() => closeError()}
          closeSuccess={() => closeSuccess()}
          successOpen={successOpen}
          errorOpen={errorOpen}
        >
        </SuccessError>
        <ThemeProvider theme={theme}>
          <Title>{props.title}</Title>
          <FormGroup>
            <FormControlLabel control={<Checkbox checked={hideCompleteRequests} onChange={handleCompleteRequestChange} />} label="Show Completed requests" />

          </FormGroup>
          <Paper
            style={{ maxHeight: 200, overflow: 'auto' }}
          >
            {/* <CheckBox checked={hideCompleteRequests} onClick={handleCompleteRequestChange}></CheckBox>   */}

            <Table  >
              <TableHead >
                <TableRow>
                  <TableCell style={{ width: '15%' }} align="left">Date</TableCell>
                  <TableCell style={{ width: '15%' }} align="left">Status</TableCell>
                  <TableCell style={{ width: '15%' }} align="left">By</TableCell>
                  <TableCell style={{ width: '15%' }} align="left">Vendor</TableCell>
                  <TableCell style={{ width: '40%' }} align="left">Notes</TableCell>
                  <TableCell style={{ width: '40%' }} align="left">Action</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {props.rows.map(row => (

                  //hide the completed requests
                  (!hideCompleteRequests && row.status === 2) ? null :

                    <TableRow key={row.requestId}>
                      <TableCell component="th" scope="row">
                        {row.requestedOn}
                      </TableCell>
                      {(row.status === 2) &&
                        <TableCell align="left"><Box sx={{ color: 'green' }} >Completed</Box></TableCell>
                      }
                      {(row.status === 0) &&
                        <TableCell align="left"><Box sx={{ color: 'red' }} >To Vendor</Box></TableCell>
                      }
                      {(row.status === 1) &&
                        <TableCell align="left"><Box sx={{ color: 'orange' }} >In Progress</Box></TableCell>
                      }
                      <TableCell align="left">{row.requestedBy}</TableCell>

                      <TableCell align="left">
                        {/* {(row.reminderSentOn) &&
                        (row.reminderSentOn)
                      } */}
                        {row.vendorName}
                      </TableCell>
                      <TableCell align="left">{row.notes}</TableCell>
                      <TableCell align="left">
                        {(row.status === 1 || row.status == 0) &&
                          <TableCell align="left"><Button color="primary" onClick={(event) => {
                            showSendReminder(event, row);
                          }} variant="outlined">Reminder</Button></TableCell>
                        }
                        {(row.status === 1 || row.status == 0) &&
                          <TableCell align="left"><Button color="primary" onClick={(event) => {
                            showRemoveRequest(event, row);
                          }} variant="outlined">Remove</Button></TableCell>
                        }
                      </TableCell>

                    </TableRow>
                ))}
              </TableBody>
            </Table>

          </Paper>
        </ThemeProvider>
        <Dialog open={openRemoveRequest} maxWidth='sm' fullWidth >
          <DialogTitle>
            <Box
              component="span"
              m={1}
              display="flex"
              justifyContent="space-between"
              alignItems="center"
            >
              Are you sure you want to remove this request?
            </Box>
          </DialogTitle>
          <DialogActions>
            <Button color="primary" onClick={removeRequest} >Remove</Button>
            <Button onClick={() => closeDialog()}>Cancel</Button>
          </DialogActions>
        </Dialog>
        <Dialog open={openReminder} maxWidth='sm' fullWidth >
          <DialogTitle>
            <Box
              component="span"
              m={1}
              display="flex"
              justifyContent="space-between"
              alignItems="center"
            >
              Vendor PIA Request Reminder
            </Box>
          </DialogTitle>

          <form>
            <DialogContent>
              <DialogContentText>
              </DialogContentText>
              <Fragment>
                <Paper variant="outlined" >
                  {/* {props.masterPiaExists && (<>
                    <Box px={3} py={2}>

                      <p>
                        <Typography variant="h8" color="error" align="center"> <b>Warning:</b>
                          You are initiating a PIA request with a vendor that already has an active PIA in the Master list.
                        </Typography>
                      </p>
                      <p>
                        <Typography variant="h8" color="error" align="center">
                          If you still want a vendor completed PIA for this software, please email contact@theprocesspros.ca and explain the request and we will ensure this work is done without PIA duplication.
                        </Typography>
                      </p>
                    </Box>

                  </>
                  )} */}

                  <Box px={3} py={2}>
                    <Grid item xs={12} sm={12}>
                      <TextField
                        id="vendorId"
                        name="vendorId"
                        label="Vendor Email"
                        hidden
                        value={props.vendorId}
                        margin="dense"
                        {...register('vendorId')}
                      />

                    </Grid>
                    <Grid item xs={12} sm={12}>
                      <TextField
                        id="accessToken"
                        name="accessToken"
                        label="accessToken"
                        hidden
                        value={props.accessToken}
                        margin="dense"
                        {...register('accessToken')}
                      />

                    </Grid>
                    <Grid item xs={12} sm={12}>
                      <TextField
                        required
                        id="email"
                        name="email"
                        label="Vendor Email"
                        fullWidth
                        value={sentTo}
                        onChange={(event) => {
                          setSentTo(event.target.value);
                        }}
                        margin="dense"
                      // {...register('sentTo')}
                      />
                      <Typography variant="inherit" color="error.main">
                        {errors.email?.message}
                      </Typography>
                    </Grid>
                    <Grid item xs={12} sm={12}>
                      <TextField
                        required
                        id="subject"
                        name="subject"
                        label="Subject"
                        fullWidth
                        margin="dense"
                        value={subject}
                        onChange={(event) => {
                          setSubject(event.target.value);
                        }}
                      //{...register('subject')}
                      />
                      <Typography variant="inherit" color="error.main">
                        {errors.subject?.message}
                      </Typography>
                    </Grid>

                    <Grid item xs={12} sm={12}>
                      <TextField
                        multiline
                        id="note"
                        name="note"
                        label="Email Body"
                        fullWidth
                        rows={10}
                        value={emailBody}
                        onChange={(event) => {
                          setEmailBody(event.target.value);
                        }}
                        margin="dense"
                      //{...register('note')}
                      />
                      <Typography variant="inherit" color="error.main">
                        {errors.note?.message}
                      </Typography>
                    </Grid>
                  </Box>

                </Paper>
              </Fragment>
            </DialogContent>
            <DialogActions>

              <Button color="primary" onClick={handleSubmit(requestSubmit)} >Send</Button>


              <Button onClick={() => closeDialog()}>Cancel</Button>
            </DialogActions>
          </form>
        </Dialog>
      </React.Fragment>
    );
  }
}
export default RequestCard;